import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";

export class LadleHMRepository {
	private axios: Axios;
	constructor() {
		this.axios = axiosInstance;
		this.getLadles = this.getLadles.bind(this);
		this.updateLadleHeatMetrics = this.updateLadleHeatMetrics.bind(this);
	}

	async getLadles() {
		try {
			const ladles = await this.axios.get("/Ladle/");

			return {
				ok: true,
				ladles: ladles.data,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}
	async updateLadleHeatMetrics(ladleId: string | number, dateTime: string) {
		try {
			const date = dateTime === "" ? null : dateTime;
			const ladle = ladleId === "all" ? null : ladleId;
			const resp = await this.axios.patch(`/HeatMetric/ladle-metrics`, {
				ladle,
				date,
			});
			return {
				ok: true,
				resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
}

export const { getLadles, updateLadleHeatMetrics } = new LadleHMRepository();
